import { render, staticRenderFns } from "./zzgzb.vue?vue&type=template&id=7d6c5753&scoped=true&"
import script from "./zzgzb.vue?vue&type=script&lang=js&"
export * from "./zzgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c5753",
  null
  
)

export default component.exports